export default {
  configName: 'Tên cấu hình',
  configAmount: 'Định cấu hình hạn ngạch',
  update: 'Thay mới',

  cancel: 'Hủy bỏ',
  success: 'thành công',
  error: 'thất bại',
  del: 'xóa bỏ',
  search: '搜索',
  detail: '详情',
  editor: '编辑',
  empty: '清空',
  emptyValue: '空值',
  add: '新增',
  export: '导出',
  hint: '提示',
  withdraw: '提现',
  review: '审核',
  pass: '通过',
  reject: '拒绝',
  test: '测试',
  next: '下一步',
  start: '启用',
  start1: 'Bật làm mới tự động',
  stop: 'vô hiệu hóa',
  stop1: 'Tắt tính năng làm mới tự động',
  submit: 'nộp',
  recharge: 'nạp tiền',
  transfer: 'Chuyển ví',
  callback: 'gọi lại'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/sysConfig.js